module.exports = __webpack_public_path__ + "img/closeImg.35c88634.png";